import {$s} from '@/app'

/** Close filters, categories, cart rail overlay, and mobile utilities panel. */
export function close_portal_shop_overlays() {
    $s.panels.view.filters.collapsed = true
    $s.panels.view.categories.collapsed = true
    $s.panels.context.collapsed = true
    $s.panels.view.menu.collapsed = true
}
